import { jsx as _jsx } from "react/jsx-runtime";
import * as styled from './ButtonGroup.style';
import { ButtonGroupDirection } from './ButtonGroup.types';
export function ButtonGroup({ children, direction }) {
    return (_jsx(styled.Container, { "$direction": direction, children: children }));
}
ButtonGroup.Direction = ButtonGroupDirection;
